/* eslint-disable import/prefer-default-export */
export function toTitleCase(sentence: string | undefined): string {
  if (!sentence) {
    return '';
  }

  return sentence.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}
